import { DataTool } from './DataTool'

interface Props {
  planOrganizationTaskId: number
  completed: boolean
  dueDate: Date
}
export const PeerToPeerDataCollectionSystemTool = (props: Props): JSX.Element => {
  const instructionsURL = 'https://www.gvsu.edu/autismcenter/2025-2026-rcn-application-and-contract-forms-595.htm#:~:text=PEER%20TO%20PEER%20(P2P)%20DATA%20COLLECTION%20SYSTEM'

  return (
    <DataTool
      planOrganizationTaskId={props.planOrganizationTaskId}
      completed={props.completed}
      title='Peer to Peer Data Collection System'
      dueDate={props.dueDate}
      instructionsUrl={instructionsURL}
      color='var(--light-blue-700)'
      successMessage='Peer to Peer Data Collection System Updated'
      dataTestId='peerToPeerDataCollectionSystemTool'
    />
  )
}
